module.exports = __webpack_public_path__ + "img/contactItem1.c033c539.png";